import styled, { css } from 'styled-components'
import { BREAKPOINT } from '../../constants'

export const Card = styled.div`
  margin: 20px auto;
  width: 840px;
  box-sizing: border-box;
  padding: 50px;
  background: white;
  border: 1px solid rgba(130,130,130,.2);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08), 0 -2px 3px 0 rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  margin-top: 65px;

  ${props => props.blank && css`
    background: transparent;
    border: 0;
    box-shadow: none;
    padding:0;
  `}


  @media (max-width: 880px) {
    width: calc(100% - 10px);
  }
  
  @media (max-width: ${BREAKPOINT.MEDIUM}) {
    margin: 0;
    max-width: 600px;
    margin: auto;
  }

  @media (max-width: ${BREAKPOINT.SMALL}) {
    padding: 10px;
    padding-bottom: 30px;
    margin: auto;
    width: calc(100% - 10px);
  }
`

export const LinkText = styled.a`
  color: #2e5f62;
`
